import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector"; // Import the language detector
import translationEN from "./locales/en/translation.json";
import translationAM from "./locales/hy/translation.json";
import translationRU from "./locales/ru/translation.json";

// the translations
const resources = {
	hy: {
		translation: translationAM,
	},
	en: {
		translation: translationEN,
	},
	ru: {
		translation: translationRU,
	},
};

i18n
	.use(LanguageDetector) // Use the language detector plugin
	.use(initReactI18next) // Passes i18n down to react-i18next
	.init({
		resources,
		fallbackLng: "hy", // Fallback language
		detection: {
			// Language detection settings

			detection: {
				order: ["path", "navigator"],
				caches: ["localStorage", "cookie"], // Optionally store language preferences
			},
		},
		interpolation: {
			escapeValue: false, // React already protects from XSS
		},
	});

export default i18n;
